import { SvgProps } from '..'
import BaseSvg from '../BaseSvg'

type Props = SvgProps & {
  filled?: boolean
}

const Mail: React.FC<Props> = ({ className, filled = false }) => {
  if (filled) {
    return (
      <BaseSvg className={className} viewBox="0 0 14 12">
        <path
          clipRule="evenodd"
          d="M6.99769 6.96891L13.6673 4.46891V10.3022C13.6673 11.2227 12.9211 11.9689 12.0007 11.9689H2.00065C1.08018 11.9689 0.333984 11.2227 0.333984 10.3022V4.46891L6.99769 6.96891ZM0.333984 1.96891C0.333984 1.04844 1.08018 0.302246 2.00065 0.302246H12.0007C12.9211 0.302246 13.6673 1.04844 13.6673 1.96891V2.80225L7.01517 5.30225L0.333984 2.80225V1.96891Z"
          fillRule="evenodd"
        />
      </BaseSvg>
    )
  }
  return (
    <BaseSvg className={className} viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 1.63477C15.1046 1.63477 16 2.5302 16 3.63477V13.6348C16 14.7393 15.1046 15.6348 14 15.6348H2C0.89543 15.6348 0 14.7393 0 13.6348V3.63477C0 2.5302 0.89543 1.63477 2 1.63477H14ZM14 7.38477L7.99645 9.63477L2 7.38477V13.6348H14V7.38477ZM14 3.63477H2V5.38277L8.01742 7.63477L14 5.38677V3.63477Z" />
    </BaseSvg>
  )
}

export default Mail
